<template>
	<div class="">
		<div  class="col-sm-12 col-md-12  col-lg-12  float-left">
			<SentimentTrend title="" subText="" modal="20"  zoom_start="70"></SentimentTrend>
		</div>
	</div>
</template>

<script>
	import SentimentTrend from 'components/sentiment/SentimentTrend.vue'
	
	export default {
		data() {
			return {
			}
		},
		components: {
			SentimentTrend,
			
		},
		methods: {
	
		}
	}
</script>

<style scoped>
</style>
